import { render } from "./my-title.vue?vue&type=template&id=17fed182"
import script from "./my-title.vue?vue&type=script&lang=js"
export * from "./my-title.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__